/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Faq as FaqType } from 'libs/http/api/content/content.types';

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';

import styles from './FaqSection.module.scss';

import type { FaqSectionProps } from './FaqSection.types';

export const FaqSection = ({ topic, className }: FaqSectionProps) => {
  const { t } = useInt();

  if (!topic.faq.length) {
    return null;
  }

  const data: FaqType[] = topic.faq.map(([question, answer], index) => ({
    id: `${topic.slug}-faq-${index}`,
    question,
    answer,
  }));

  return (
    <section id="faq" className={cn(styles['section'], className)}>
      <Faq title={t('Frequently asked questions')} data={data} className={styles['faq']} />
    </section>
  );
};
